<template>
  <div class="student-data__component">
    <div class="student-view__panel-content">
      <div class="panel__row">
        <student-info label="CEP" :value="houseData.zipCode" />
        <student-info label="Estado" :value="houseDataState.name" />
        <student-info label="Cidade" :value="houseDataCity.name" />
      </div>
      <div class="panel__row">
        <student-info label="Bairro" :value="houseData.neighborhood" />
        <student-info label="Rua" :value="houseData.street" />
        <student-info label="Número" :value="houseData.number" />
      </div>
      <div class="panel__row">
        <student-info label="Complemento" :value="houseData.complement" />
      </div>
    </div>
  </div>
</template>
<script>
import StudentInfo from 'components/StudentInfo';

export default {
  components: {
    StudentInfo,
  },
  props: {
    houseDataCity: {
      type: Object,
      default: () => {},
    },
    houseDataState: {
      type: Object,
      default: () => {},
    },
    houseData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
